import { render, staticRenderFns } from "./ImageCaption.vue?vue&type=template&id=bd061a8a&"
import script from "./ImageCaption.vue?vue&type=script&lang=js&"
export * from "./ImageCaption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/Kristian/Local Sites/boligvelger/app/public/wp-content/plugins/ensign-boligprosjekter-blocks/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd061a8a')) {
      api.createRecord('bd061a8a', component.options)
    } else {
      api.reload('bd061a8a', component.options)
    }
    module.hot.accept("./ImageCaption.vue?vue&type=template&id=bd061a8a&", function () {
      api.rerender('bd061a8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ImageCaption.vue"
export default component.exports